import React, { useState, useEffect } from "react";
import { Spinner } from "@/components/shared/LoadingSystem";
import "./SharedReportStyles.css";
import "./MatrizCausaEfecto.css";
import apiFiles from "@shared/api/filesService";
import { sileo } from "sileo";

const MatrizCausaEfecto = ({ seccion, reportInfo, renderCase }) => {
  const [matrices, setMatrices] = useState([]);
  const [loading, setLoading] = useState(true);
  // Nuevos estados para el modal
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedMaquina, setSelectedMaquina] = useState(null);

  // Función para abrir el modal con la imagen seleccionada
  const openImageModal = (imageUrl, maquina) => {
    setSelectedImage(imageUrl);
    setSelectedMaquina(maquina);
    setModalVisible(true);
    // Prevenir scroll en el body cuando el modal está abierto
    document.body.style.overflow = "hidden";
  };

  // Función para cerrar el modal
  const closeModal = () => {
    setModalVisible(false);
    setSelectedImage(null);
    setSelectedMaquina(null);
    // Restaurar scroll en el body
    document.body.style.overflow = "auto";
  };

  // Cargar las imágenes de las matrices cuando el componente se monta
  useEffect(() => {
    const cargarMatrices = async () => {
      try {
        setLoading(true);

        if (!seccion.maquinas || seccion.maquinas.length === 0) {
          setLoading(false);
          return;
        }

        // Filtrar máquinas que tienen matriz causa-efecto
        const maquinasConMatriz = seccion.maquinas.filter(
          (maq) => maq.matrizcausaefecto
        );

        if (maquinasConMatriz.length === 0) {
          setLoading(false);
          return;
        }

        // Cargar las imágenes para cada matriz
        const matricesConUrl = await Promise.all(
          maquinasConMatriz.map(async (maquina) => {
            try {
              const imageUrl = await apiFiles.getImage(
                maquina.matrizcausaefecto
              );
              return {
                ...maquina,
                imageUrl,
              };
            } catch (error) {
              console.error(
                `Error al cargar la imagen de matriz para máquina ${maquina.idmaquina}:`,
                error
              );
              return {
                ...maquina,
                error: "No se pudo cargar la imagen",
              };
            }
          })
        );

        setMatrices(matricesConUrl);
      } catch (error) {
        console.error("Error al cargar las matrices causa-efecto:", error);
        sileo.error({ title: "Error al cargar las matrices causa-efecto" });
      } finally {
        setLoading(false);
      }
    };

    cargarMatrices();
  }, [seccion]);

  return (
    <div className="sr-section matriz-section">
      <h3 className="sr-section-title">{seccion.nombreseccion}</h3>

      {loading ? (
        <Spinner
          size="large"
          text="Cargando matrices causa-efecto..."
          centered
        />
      ) : matrices.length > 0 ? (
        <div className="matriz-grid">
          {matrices.map((maquina) => (
            <div key={maquina.idmaquina} className="matriz-card">
              <div className="matriz-card-body">
                {maquina.error ? (
                  <div className="matriz-error-message">
                    <i className="fa-solid fa-triangle-exclamation"></i>
                    <span>{maquina.error}</span>
                  </div>
                ) : maquina.imageUrl ? (
                  <div className="matriz-image-container">
                    <img
                      src={maquina.imageUrl}
                      alt={`Matriz Causa-Efecto de Máquina #${maquina.numero}`}
                      className="matriz-image"
                      onClick={() => openImageModal(maquina.imageUrl, maquina)}
                    />
                    <div className="matriz-image-overlay">
                      <i className="fa-solid fa-magnifying-glass-plus"></i>
                      <span>Ampliar</span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="matriz-empty">
          <i className="fa-solid fa-circle-info"></i>
          <p>
            No hay matrices causa-efecto disponibles para las máquinas de este
            reporte.
          </p>
        </div>
      )}

      {/* Renderizamos los items normales de la sección si existen */}
      {seccion.items && seccion.items.length > 0 && (
        <div className="matriz-items-container">
          {seccion.items.map((item) => (
            <div key={item.id} className="sr-item">
              <p>{item.descripcion}</p>
              {item.respuesta && (
                <span className="matriz-item-response">{item.respuesta}</span>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Modal para imagen ampliada */}
      {modalVisible && selectedImage && (
        <div className="matriz-modal" onClick={closeModal}>
          <div
            className="matriz-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="matriz-modal-close" onClick={closeModal}>
              &times;
            </span>
            {selectedMaquina && (
              <div className="matriz-modal-header">
                <h4>Matriz Causa-Efecto</h4>
                <p>
                  Máquina #{selectedMaquina.numero} - {selectedMaquina.tipo}
                </p>
              </div>
            )}
            <div className="matriz-modal-image-container">
              <img
                src={selectedImage}
                alt="Matriz Causa-Efecto Ampliada"
                className="matriz-modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MatrizCausaEfecto;
